import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetProductsSidebarCounts as GetProductsSidebarCountsQuery,
    GetProductsSidebarCounts_productsSidebarCounts as ProductsSidebarCounts,
} from 'nutshell-graphql-types';

import GET_PRODUCTS_SIDEBAR_COUNTS from '../queries/get-products-sidebar-counts.graphql';

export const useGetProductsSidebarCounts = (): {
    productsSidebarCounts: ProductsSidebarCounts | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const {loading, data, error} = useQuery<GetProductsSidebarCountsQuery, Record<any, any>>(
        GET_PRODUCTS_SIDEBAR_COUNTS,
        {
            fetchPolicy: 'cache-and-network',
        }
    );

    return {
        productsSidebarCounts:
            data && data.productsSidebarCounts ? data.productsSidebarCounts : null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
